import React from "react";
import { Form, Select, Input, Space } from "antd";

const SelectWithOtherInput = ({
  name,
  label = null,
  options,
  form,
  inputPlaceholder = "Specify Other",
  otherFieldName = null,
  otherLabel = null,
  otherValue = "others",
  rules = [],
  inputRules = [],
  selectProps = {},
  inputProps = {},
  spaceSize = "large",
  selectWidth = 200,
  inputWidth = null,
}) => {
  const otherName = otherFieldName || `${name}_others`;
  const resolvedInputWidth =
    inputProps?.style?.width ?? (inputWidth ?? selectWidth);
  const showOtherLabel =
    otherLabel != null && String(otherLabel).trim().length > 0;

  return (
    <>
      <style>
        {`
          @media (min-width: 769px) {
            .select-other-space {
              flex-wrap: nowrap !important;
            }
          }

          @media (max-width: 768px) {
            .select-other-space {
              flex-direction: column !important;
              align-items: stretch !important;
              width: 100% !important;
              gap: 8px !important;
              row-gap: 8px !important;
            }

            .select-other-space .ant-form-item {
              width: 100% !important;
              margin-bottom: 0 !important;
            }

            .select-other-space .ant-select,
            .select-other-space .ant-input {
              width: 100% !important;
            }
          }

          .select-other-space .select-other-input-item .ant-form-item-label > label {
            visibility: hidden;
          }

          .select-other-space .ant-form-item {
            margin-bottom: 0;
          }
        `}
      </style>

      <Space size={spaceSize} className="select-other-space" align="end" wrap>
        <Form.Item
          name={name}
          label={label}
          rules={rules}
          style={{ width: selectWidth }}
        >
          <Select
            style={{ width: selectWidth }}
            popupClassName="custom-dropdown"
            {...selectProps}
            options={options}
            onChange={() => {
              if (selectProps.onChange) selectProps.onChange();
            }}
          />
        </Form.Item>

        {form.getFieldValue(name) === otherValue && (
          <Form.Item
            label={showOtherLabel ? otherLabel : " "}
            colon={false}
            className="select-other-input-item"
            name={otherName}
            rules={inputRules}
            style={{ width: resolvedInputWidth }}
          >
            <Input
              placeholder={inputPlaceholder}
              {...inputProps}
              style={{ ...(inputProps?.style || {}), width: resolvedInputWidth }}
            />
          </Form.Item>
        )}
      </Space>
    </>
  );
};

export default SelectWithOtherInput;
